export default __webpack_public_path__ + "static/media/funky.1f02d686.png";